module.exports = {"469026100":"石碌镇","469026101":"叉河镇","469026102":"十月田镇","469026103":"乌烈镇","469026104":"昌化镇","469026105":"海尾镇","469026106":"七叉镇","469026200":"王下乡","469026500":"国营霸王岭林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469026.json
// module id = 2207
// module chunks = 0